<template>
  <div
    class="mainIframe"
    id="mainIframeContainer"
    :style="this.$store.state.style"
  >
    <div
      id="iframeContianer"
      ref="iframeContianer"
      v-bind:class="{
        minimizeFrame: iframeMinimized,
        opened: !allIframesClosed,
      }"
    >
      <div class="nav-iframe" id="iframeHolder" v-if="!allIframesClosed">
        <frame-nav
          :key="this.$vnode.data.key"
          v-on:message-selected="messageSelecteted"
          v-on:cycle-completion-notification="cycleCompleted"
          v-on:forward="forwardHandller"
          v-on:back="backHandller"
          :messages="messages"
          :currentNodeId="currentNodeId"
          :nodeUniqueId="currentNodeUniqueId"
          :intermediateViewDisplayed="intermediateViewDisplayed"
          :returnMode="returnMode"
          ref="frameNavComponent"
        ></frame-nav>
        <appComponent
          v-for="(comp, index) in iframes"
          :key="index"
          :src="comp.src"
          :msg="comp.msg"
          :displayed="comp.displayed"
          :nodeUniqueId="comp.uniqueId"
          :currentNodeId="comp.nodeId"
          :appType="getAppType(comp.nodeId)"
          :sentMessage="comp.sentMessage"
          v-on:iframe-minimized="minimizeIframe"
          v-on:object-store-updated="ObjectStoreUpdated"
          v-on:iframe-closed="closeIframe"
          v-on:message-selected="messageSelecteted"
          v-on:message-returned="messageReturned"
          :checkIfMessageBelongsToApp="checkIfMessageBelongsToApp"
          ref="appComponentList"
        ></appComponent>
        <intermediate-view-component
          v-if="intermediateViewDisplayed"
          :nodes="intermediateViewNodes"
          v-on:intermediate-view-item-selected="intermediateViewItemSelected"
          v-on:iframe-closed="closeIntermediateView"
          v-on:iframe-minimized="minimizeIframe"
        ></intermediate-view-component>
      </div>
    </div>
  </div>
</template>

<script>
import FrameNav from "./../viewMode/FrameNav.vue";
import portalAPI from "../../services/portalService";
import appComponent from "./appComponent.vue";
import IntermediateViewComponent from "./IntermediateViewComponent.vue";
import _ from "lodash";

let pAPI = new portalAPI();

export default {
  name: "OpenedApp",
  props: ["maskedUrl", "appId", "appName", "isMinimized", "appType", "user"],
  data() {
    return {
      currentIframe: null,
      currentNodeId: null,
      currentNodeUniqueId: null,
      objStore: [],
      iframes: [],
      nodesTree: [],
      intermediateViewDisplayed: false,
      intermediateViewNodes: null,
      iframeMinimized: false,
      returnMode: false,
      sentMessage: null,
      forwardNodes: null,
    };
  },

  components: {
    FrameNav,
    appComponent,
    IntermediateViewComponent,
  },

  methods: {
    closeIntermediateView() {
      this.intermediateViewDisplayed = false;
      this.$refs.frameNavComponent.enableforwardButton();
      this.$refs.frameNavComponent.enableBackwardButton();
    },
    minimizeIframe() {
      this.iframeMinimized = true;
      this.$emit("iframe-minimized", this.appId);
    },

    ObjectStoreUpdated(_objStore) {
      //this.objStore = _objStore;
      var filteredObjStore = _objStore.filter((_o) =>
        this.objStore.every(
          (o) => _o.msgId !== o.msgId && _o.nodeUniqueId == o.nodeUniqueId
        )
      );

      var removeObjStore = this.objStore.filter((o) =>
        _objStore.every(
          (_o) => o.msgId !== _o.msgId && o.nodeUniqueId == _o.nodeUniqueId
        )
      );

      _.forEach(removeObjStore, (or) => {
        _.remove(this.objStore, (o) => {
          o.msgId == or.msgId && o.nodeUniqueId == or.nodeUniqueId;
        });
      });

      _.forEach(filteredObjStore, (of) => {
        this.objStore.push(of);
      });
    },
    intermediateViewItemSelected(node) {
      let newIndex = _.findIndex(
        this.iframes,
        (item) => item.uniqueId == node.uniqueId
      );
      this.setCurrentIframe(newIndex);
      this.intermediateViewDisplayed = false;
    },
    setCurrentIframe(newIndex) {
      _.forEach(this.iframes, (iframe) => {
        iframe.displayed = false;
      });
      this.returnMode = this.iframes[newIndex].returnMode;
      this.iframes[newIndex].displayed = true;
      this.currentIframe = this.iframes[newIndex].src;
      this.currentNodeId = this.iframes[newIndex].nodeId;
      this.currentNodeUniqueId = this.iframes[newIndex].uniqueId;
      this.frameNavButtonsDisability(this.currentNodeUniqueId);
    },
    frameNavButtonsDisability(currentNodeUniqueId) {
      let node = this.findNode(currentNodeUniqueId);

      //check children that are not closed to enable or disable the forward button
      let children = [];
      _.forEach(node.children, (item) => {
        if (!this.nodesTree[item.level][item.index].isClosed)
          children.push(this.nodesTree[item.level][item.index]);
      });

      //handle forward button enable and disable
      if (node.children && node.children.length && children.length) {
        this.$refs.frameNavComponent.enableforwardButton();
      } else {
        this.$refs.frameNavComponent.disableforwardButton();
      }
      //handle backward button enable and disable
      if (node.parents && node.parents.length) {
        this.$refs.frameNavComponent.enableBackwardButton();
      } else {
        this.$refs.frameNavComponent.disableBackwardButton();
      }
    },
    forwardHandller() {
      let that = this;
      let node = this.findNode(this.currentNodeUniqueId);
      if (node.children && node.children.length) {
        if (node.children.length > 1) {
          let children = [];
          _.forEach(node.children, (item) => {
            children.push(that.nodesTree[item.level][item.index]);
          });
          let openedChild = children.filter((n) => n.isClosed == false);
          if (openedChild.length > 1) that.setForwardNodes(children);
          else that.forwardItemHandler(openedChild);
        } else {
          let level = node.children[0].level;
          let index = node.children[0].index;

          let childNode = that.nodesTree[level][index];
          that.forwardItemHandler([childNode]);
        }
      }
    },
    forwardItemHandler(nodesArray) {
      var forwardWindow = this.getForwardMode(nodesArray);
      if (nodesArray && forwardWindow) {
        this.intermediateViewNodes = nodesArray;
        this.intermediateViewDisplayed = true;
        this.$refs.frameNavComponent.disableBackwardButton();
        this.$refs.frameNavComponent.disableforwardButton();
      } else {
        let node = nodesArray[0];
        let newIndex = _.findIndex(
          this.iframes,
          (item) => item.uniqueId == node.uniqueId
        );
        this.setCurrentIframe(newIndex);
      }
    },
    getForwardMode(ForwardNodes) {
      if (Object.keys(ForwardNodes).length > 1) {
        return true;
      } else {
        if (ForwardNodes[Object.keys(ForwardNodes)[0]].length > 1) return true;
        else return false;
      }
    },
    setForwardNodes(nodes) {
      let openedNodes = nodes.filter((n) => n.isClosed == false);
      this.forwardNodes = _.groupBy(openedNodes, "name");
      this.forwardItemHandler(this.forwardNodes);
    },
    backHandller() {
      let that = this;
      let node = that.findNode(that.currentNodeUniqueId);
      if (node.parents && node.parents.length) {
        let level = node.parents[0].level;
        let index = node.parents[0].index;

        let parentNode = that.nodesTree[level][index];
        let newIndex = _.findIndex(
          that.iframes,
          (item) => item.uniqueId == parentNode.uniqueId
        );
        that.setCurrentIframe(newIndex);
      }
    },
    setChildNode(childNode) {
      let node = this.findNode(childNode.parent);
      if (node) {
        childNode.level = node.level + 1;
        childNode.index = node.children.length;
        childNode.parents.push({
          level: node.level,
          index: node.index,
        });
        node.children.push({
          level: childNode.level,
          index: childNode.index,
        });

        if (!this.nodesTree[childNode.level])
          this.nodesTree[childNode.level] = [];
        this.nodesTree[childNode.level].splice(childNode.index, 0, childNode);
      }
    },
    findNode(uniqueId) {
      let foundNode;
      _.forEach(this.nodesTree, (nodes) => {
        _.forEach(nodes, (node) => {
          if (node.uniqueId == uniqueId) {
            foundNode = node;
            return false;
          }
        });
        if (foundNode) return false;
      });
      return foundNode;
    },
    messageSelecteted(message, nodeId, returnMode = false, secAddedToUrl = "") {
      let that = this;

      let navigateionUrl =
        secAddedToUrl.length > 0
          ? `node/navigateTo/${nodeId}?sec_added_to_url=${encodeURIComponent(
              secAddedToUrl
            )}`
          : `node/navigateTo/${nodeId}`;

      let destinationNode = that.$store.getters.userNodes.find(
        (node) => node.id == nodeId
      );

      //if node doesn't exists search on it's children
      if (!destinationNode) {
        destinationNode = that.$store.getters.userNodes.find(
          (node) =>
            node.children.length > 0 &&
            node.children.find((c) => c.id == nodeId)
        );
      }

      pAPI.navigateTo(navigateionUrl).then((response) => {
        pAPI
          .AddEvent({
            type: "APPLICATION_ACCESS",
            subtype: null,
            source: that.appName,
            destination: destinationNode.name,
            user_name: that.user.profile.email,
          })
          .then((res) => {
            // console.log(res);
          })
          .catch((error) => {
            console.log("failed to add event " + error);
          });
        let iframeUrl = response.data;
        let iframe = {
          src: iframeUrl,
          msg: message,
          displayed: true,
          nodeId: nodeId,
          uniqueId: _.uniqueId(),
          returnMode: returnMode,
          sentMessage: null,
        };

        that.setChildNode({
          id: nodeId,
          uniqueId: iframe.uniqueId,
          name: message[0].nodeName,
          messageName: message.map((msg) => msg.name).join(", "),
          parent: this.currentNodeUniqueId,
          type: message[0].messageType,
          isClosed: false,
          children: [],
          parents: [],
        });

        that.returnMode = returnMode;
        that.iframes.push(iframe);

        let newIndex = _.findIndex(
          this.iframes,
          (item) => item.uniqueId == iframe.uniqueId
        );
        this.setCurrentIframe(newIndex);
      });
    },
    messageReturned(message) {
      //console.log("messageReturned")
      let that = this;
      let node = that.findNode(that.currentNodeUniqueId);
      let parent = node.parent;
      that.markNodeAndChildDeleted(that.currentNodeUniqueId);
      let parentIframeIndex = that.iframes.findIndex(
        (f) => f.uniqueId == parent
      );
      that.setCurrentIframe(parentIframeIndex);
      let currentIframe = this.iframes[parentIframeIndex];
      currentIframe.sentMessage = message;
    },
    checkIfMessageBelongsToApp(messageType) {
      var msgRcvSetting = this.$refs.frameNavComponent.msgRcvSetting;
      for (var i in msgRcvSetting) {
        for (var j in msgRcvSetting[i]["nodeSettings"]) {
          if (messageType === msgRcvSetting[i]["nodeSettings"][j].messageType) {
            return true;
          }
        }
      }
      return false;
    },
    cycleCompleted() {
      let currentIframe = this.$refs.appComponentList.filter(
        (currentIframe) => currentIframe.displayed
      )[0];
      var now = new Date();
      var epoch = Math.round(now.getTime() / 1000);
      /*
       * The epoch variable is not used and needs to be removed from this function
       * and all portalClient versions.
       */
      currentIframe.cycleCompletion(epoch);
    },
    closeIframe(uniqueCloseNodeId, currentcloseNodeId) {
      //console.log("CLOSE IFrame: " + "uniqueCloseNodeId ==> " + uniqueCloseNodeId +"currentcloseNodeId ==> " +  currentcloseNodeId)
      let node = this.findNode(uniqueCloseNodeId);
      let parent = node.parent;
      this.markNodeAndChildDeleted(uniqueCloseNodeId);
      let parentIframeIndex = this.iframes.findIndex(
        (f) => f.uniqueId == parent
      );
      if (this.iframes.length > 0) {
        this.setCurrentIframe(parentIframeIndex);
      } else {
        this.$emit("iframe-closed", currentcloseNodeId);
      }
    },
    removeiframe(iframeUniqueIndex) {
      let that = this;
      let iframeIndex = that.iframes.findIndex(
        (f) => f.uniqueId == iframeUniqueIndex
      );
      if (iframeIndex >= 0) {
        that.iframes.splice(iframeIndex, 1);
      }
    },

    markNodeAndChildDeleted(uniqueNodeId) {
      let that = this;
      //console.log("Delete uniqueNodeId :" + uniqueNodeId)
      that.nodesTree.forEach((node) => {
        let nodeIndex = node.findIndex((n) => n.uniqueId == uniqueNodeId);
        if (nodeIndex >= 0) {
          //check if there are children for this node and update their close flag
          if (node[nodeIndex].children.length > 0) {
            node[nodeIndex].children.forEach((ch) => {
              that.markNodeAndChildDeleted(
                that.nodesTree[ch.level][ch.index].uniqueId
              );
            });
          }

          //update parent node close flag
          node[nodeIndex].isClosed = true;
          that.removeiframe(node[nodeIndex].uniqueId);
        }
      });
    },
    getAppType(nodeId) {
      //if application type not the same update it
      let tempApp = this.$store.state.userNodes.filter(
        (n) => n.id == nodeId
      )[0];

      if (
        tempApp &&
        tempApp.hasOwnProperty("type") &&
        tempApp.type !== this.appType
      ) {
        return tempApp.type;
      }
      return this.appType;
    },
  },
  mounted() {
    let that = this;
    pAPI.navigateTo(this.maskedUrl).then((response) => {
      pAPI
        .AddEvent({
          type: "APPLICATION_ACCESS",
          subtype: null,
          source: "Portal",
          destination: this.appName,
          user_name: this.user.profile.email,
        })
        .then((res) => {})
        .catch((error) => {
          console.log("failed to add event " + error);
        });
      let iframe = {
        src: response.data,
        displayed: true,
        nodeId: this.appId,
        uniqueId: _.uniqueId(),
        returnMode: false,
      };
      //console.log("MOUNTED Create uniqueNodeId :" + iframe.uniqueId + " URL: "+response.data)

      that.currentNodeId = this.appId;
      that.currentNodeUniqueId = iframe.uniqueId;
      that.iframes.push(iframe);

      //root node
      that.nodesTree.push([
        {
          level: 0,
          index: 0,
          id: that.appId,
          uniqueId: iframe.uniqueId,
          name: that.appName,
          messageName: "",
          parents: null,
          type: that.appName,
          isClosed: false,
          children: [],
        },
      ]);
    });
  },
  computed: {
    messages: function () {
      let that = this;
      let msgs = that.objStore
        .filter((m) => m.nodeUniqueId == that.currentNodeUniqueId)
        .map((m) => {
          let isGroup = m.messageGroupName ? true : false;
          return {
            msgType: m.messageType,
            groupName: isGroup ? m.messageGroupName : m.name,
            groupId: isGroup ? m.messageGroupId : m.name,
            showBasedOnSettings: false,
            groupChild: isGroup
              ? that.objStore.filter(
                  (c) => c.messageGroupName == m.messageGroupName
                )
              : that.objStore.filter((c) => c.msgId == m.msgId),
          };
        });

      return _.uniqBy(msgs, "groupId");
    },
    allIframesClosed: function () {
      return this.iframes.length > 0 ? false : true;
    },
  },
  watch: {
    isMinimized: function () {
      this.iframeMinimized = this.isMinimized;
    },
  },
};
</script>
<style>
.minimizeFrame {
  display: none;
}

.mainIframe div:first-child {
  position: relative;
  z-index: 999;
}
#iframeContianer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: scale(0);
  transition: all 0.5s ease-in-out;
  opacity: 0;
}
header {
  background: #fff;
  padding: 14px 1rem;
  position: fixed;
  height: 75px;
  border: solid 1px #eaeff5;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: var(--header_zindex);
}

#iframeContianer nav {
  background: var(--nav_bg_color);
  position: fixed;
  width: 80px;
  height: var(--nav_height); /* fallback if css var is not supported*/
  height: var(--nav_height_mobile);
  top: var(--nav_position);
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
  z-index: 1;
}
#iframeContianer nav button.action-button {
  background: transparent;
  border: 0;
  padding: 1rem 0.5rem;
  /* border-bottom: solid 2px #f1f1f1; */
  display: block;
  margin: 0 auto;
  position: relative;
  width: 100%;
}
#iframeContianer nav button.action-button img {
  filter: var(--nav_btn_icons);
}
#iframeContianer nav button.action-button::after {
  height: 2px;
  content: "";
  position: absolute;
  left: 17px;
  width: 50px;
  bottom: 1px;
  background: #f1f1f1;
}
#iframeContianer nav button.action-button:disabled {
  opacity: 0.6;
}
#iframeContianer nav button.action-button:focus,
.iframeContianer nav button.action-button.active {
  background: #dde5ee;
}
#iframeContianer nav button.action-button .notification {
  position: absolute;
  top: 3px;
  right: 14px;
  background: #ff796f;
  padding: 0 7px;
  color: #fff;
  line-height: 23px;
  font-size: 12px;
  border-radius: 4px;
}
#iframeContianer nav button:focus {
  outline: none;
}
#iframeContianer nav button i.fa-chevron-left,
#iframeContianer nav button i.fa-chevron-right {
  background: transparent;
  border: solid 3px #04578d;
  color: #04578d;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  line-height: 1.7rem;
  font-size: 1rem;
}
#iframeContianer nav button span {
  font-size: 12px;
  display: block;
  color: var(--nav_btn_color);
  text-transform: uppercase;
  margin-top: 7px;
  font-weight: 500;
}
#iframeContianer nav button.close span {
  font-size: 24px;
  margin-top: 0;
}
/* #iframeContianer nav button img {
  width: 30px;
} */
#iframeContianer nav button i.fa-layer-group {
  font-size: 2rem;
  color: #787d96;
}
/* #iframeContianer nav div {
  position: absolute;
  bottom: 0;
} */
#iframeContianer nav .nav-content {
  position: absolute;
  bottom: 0;
  width: 100%;
}
#iframeContainer nav .nav-icon {
  margin: 20px 0 0 23px;
  width: 30px;
  text-align: center;
  display: var(--nav_icon);
}
#iframeContianer .nav-iframe {
  display: flex;
}
#iframeContianer.opened {
  transform: scale(1);
  opacity: 1;
}
.popup-container {
  position: absolute;
  left: -500%;
  bottom: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
  z-index: 9999;
  overflow: auto;
  background: #dde5ee;
}
.popup-container.opened {
  opacity: 1;
  left: 5.3rem;
}
.popup-container .popup {
  position: absolute;
  left: 0;
  background: #dde5ee;
  padding: 0.5rem 1rem;
  width: 330px;
  min-height: 300px;
  border-top-right-radius: 5px;
  box-shadow: 2px -2px 2px #616060b0;
  color: black;
}
.popup-container .popup .submenu {
  padding: 1rem 0;
  left: -200%;
  position: absolute;
  transition: all 0.5s ease-in-out;
  top: 0;
  background: #dde5ee;
  width: 275px;
  opacity: 0;
  height: 100%;
}
.popup-container .popup .submenu.opened {
  left: 1rem;
  opacity: 1;
}
.popup-container .popup .submenu button.back {
  background: transparent;
  border: 0;
  color: #000;
  display: block;
  margin-bottom: 0;
}
.popup-container .popup .submenu ul {
  margin-top: 0.5rem;
}
.popup-container .popup .submenu button.back i.fa-chevron-left {
  border: 0 !important;
  font-size: 1rem !important;
  width: auto !important;
  height: auto !important;
}
.popup-container .popup .submenu button.launch-btn {
  background: #0078cd;
  color: #fff;
  border-radius: 20px;
  height: 29px;
  position: relative;
  bottom: 1rem;
  left: 50%;
  font-size: 14px;
  border: 0;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 80px;
  margin-top: 1rem;
  /* margin: 0 auto; */
}
.popup-container .popup button.back i {
  margin-right: 0.3rem;
}
.popup-container ul {
  padding: 0;
  margin: 1rem 0 0.5rem 1rem;
}
.popup-container ul li {
  list-style: none;
  cursor: pointer;
}
.popup-container ul li :hover {
  text-decoration: underline;
}
.popup-container .popup .appname {
  margin-left: 1.5rem;
}
.forward-popup {
  bottom: 132px;
}
</style>